import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'User sends a prompt in Agent Chat',
  name: 'canvas_agent_chat_prompt_sent',
  params: [
    {
      description: 'The length of the message sent',
      name: 'message_length',
      required: true,
      type: 'number',
    },
    {
      description: 'The ID of the canvas',
      name: 'canvas_id',
      required: true,
      type: 'string',
    },
    {
      description: 'The ID of the chat thread',
      name: 'thread_id',
      required: true,
      type: 'string',
    },
  ],
};

export default META;
